interface BadgeProps {
  label: string;
  color: string;
  bg: string;
}

export function Badge({ label, color, bg }: BadgeProps) {
  return (
    <span className="badge" style={{ color, background: bg }}>
      {label}
    </span>
  );
}
